import React, { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const banners = [
  {
    id: 1,
    title: 'Fresh Produce',
    description: 'From Your Neighborhood',
    buttonText: 'Order Now',
    image:
      'https://images.pexels.com/photos/2294471/pexels-photo-2294471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    color: 'from-amber-400 to-yellow-600',
  },
  {
    id: 2,
    title: 'Connect With Local Vendors',
    description: 'Support your local economy.',
    buttonText: 'Shop Now',
    image:
      'https://images.pexels.com/photos/1458694/pexels-photo-1458694.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    color: 'from-green-500 to-emerald-700',
  },
  {
    id: 3,
    title: 'Daily Essentials',
    description: 'Explore wide range of products from your local vendor',
    buttonText: 'Order Now',
    image:
      'https://images.pexels.com/photos/264636/pexels-photo-264636.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    color: 'from-blue-500 to-indigo-700',
  },
];

const MarketingBanners = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + banners.length) % banners.length);
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      nextSlide();
    }, 5000); // Auto advance every 5 seconds

    return () => {
      resetTimeout();
    };
  }, [currentIndex]);

  return (
    <div className="relative rounded-xl overflow-hidden shadow-sm">
      <div className="aspect-[16/6] relative overflow-hidden rounded-xl">
        <div
          className="w-full h-full transition-transform duration-500 ease-out flex"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {banners.map((banner, index) => (
            <div key={banner.id} className="min-w-full h-full flex-shrink-0">
              <div
                className={`relative w-full h-full bg-gradient-to-r ${banner.color} overflow-hidden rounded-xl`}
              >
                <div className="absolute inset-0 opacity-60 mix-blend-overlay">
                  <img
                    src={banner.image}
                    alt={banner.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="absolute inset-0 flex flex-col justify-end p-4 text-white">
                  <h3 className="text-2xl font-bold drop-shadow-md">{banner.title}</h3>
                  <p className="text-sm mt-1 drop-shadow-md">{banner.description}</p>
                  <div className="mt-6 text-gray-900 rounded-full px-4 py-1 text-sm font-medium self-start hover:bg-opacity-90 transition-all shadow-md"></div>
                  {/* <button className="mt-2 bg-white text-gray-900 rounded-full px-4 py-1 text-sm font-medium self-start hover:bg-opacity-90 transition-all shadow-md">
                    {banner.buttonText}
                  </button> */}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Slide indicators */}
        <div className="absolute bottom-2 left-0 right-0 flex justify-center space-x-2">
          {banners.map((_, index) => (
            <button
              key={index}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentIndex ? 'bg-white w-4' : 'bg-white/50'
              }`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>

      {/* Control buttons */}
      <button
        onClick={prevSlide}
        className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 flex items-center justify-center text-white hover:bg-black/40 transition-colors"
      >
        <ChevronLeft size={20} />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/30 flex items-center justify-center text-white hover:bg-black/40 transition-colors"
      >
        <ChevronRight size={20} />
      </button>
    </div>
  );
};

export default MarketingBanners;
